module.exports = __webpack_public_path__ + "static/img/month_2nd_prize.62dd02b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prize/month_2nd_prize.png
// module id = VxjM
// module chunks = 1